import { render, staticRenderFns } from "./defaultSms.vue?vue&type=template&id=25936932&scoped=true"
import script from "./defaultSms.vue?vue&type=script&lang=js"
export * from "./defaultSms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25936932",
  null
  
)

export default component.exports